import { Text } from "@chakra-ui/react";
import React, { Fragment } from "react";
import { ActionCard } from "../../components/molecules/ActionCard";
import { UnlockButton } from "./UnlockButton";

export const CalculatingCard = () => {
  return (
    <ActionCard
      heading={"Calculating recommendations..."}
      actions={<UnlockButton content={"Calculating"} isLoading={true} />}
      content={
        <>
          <Text>
            We’re calculating some recommendations for your account that may
            help you save tax, it won’t take long.
          </Text>
        </>
      }
    />
  );
};
